import http from '../../http'

const API_URL = "prevention_control" 

class PreventiveMeasuresAPI {

  async save(measures) {
    const response = await http(`${API_URL}/save`, 'POST', measures)
    return response
  }

  async getAll(companyID, page, search) {
    const response = await http(`${API_URL}/company/${companyID}?page=${page}&search=${search}`, 'POST')
    return response || null
  } 

  async get(measuresID) {
    const response = await http(`${API_URL}/${measuresID}`)
    return response || null
  }

  async update(id, measures) {
    const response = await http(`${API_URL}/update/${id}`, 'PUT', measures)
    return response
  }

  async delete(id) {
    const response = await http(`${API_URL}/delete/${id}`, 'DELETE')
    return response
  }

}

export default new PreventiveMeasuresAPI()